angular
  .module('surfsightApp.controllers')

  .controller('edgeDownloadRecordingVideoModalController', [
    '$scope',
    '$localStorage',
    '$translate',
    'dataFromCaller',
    '$mdDialog',
    function ($scope, $localStorage, $translate, dataFromCaller, $mdDialog) {
      const { notification, recordingUrl } = dataFromCaller
      const FRONT_CAMERA_ID = 1
      const REAR_CAMERA_ID = 2
      $scope.userToken = $localStorage.userToken
      const getCameraId = cameraId => {
        if ([FRONT_CAMERA_ID, REAR_CAMERA_ID].includes(cameraId)) {
          return cameraId === FRONT_CAMERA_ID ? 'RoadFacingLens' : 'InCabinLens'
        } else {
          return 'AuxiliaryCamera'
        }
      }
      $scope.recordingData = {
        cameraName: getCameraId(notification.metadata.streamId),
        recordingUrl: recordingUrl
      }

      $scope.cancel = function () {
        $mdDialog.cancel()
      }
    }
  ])
